export default "__VITE_ASSET__CLU$NGAi__"